import React, { useCallback, useEffect, useState } from "react";
import ArrowRightIcon from "assets/images/icons/left-arrow.svg";
import dayjs from "dayjs";
import "./style.scss";
import { Fields } from "../../uicomponents";
import get from "lodash/get";
import outsideClick from "../../hooks/OutsideClick";
import useTranslation from "../../hooks/useTranslation";

const Index = ({
	initialValueQuery,
	handleClick,
	handleClear,
	initialDefault,
	dropdownPosition = "left",
	startHoursInSeconds = 0,
	navigateByDay = false
}) => {
	const { tr } = useTranslation();

	const { ref, isVisible, setIsVisible } = outsideClick();

	const initialValue = {
		type: initialDefault,
		startOf: dayjs()
			.startOf(initialDefault)
			.unix(),
		endOf: dayjs()
			.endOf(initialDefault)
			.unix()
	};

	const [startValue, setStartValue] = useState(null);
	const [endValue, setEndValue] = useState(null);
	const [value, setValue] = useState(
		initialValueQuery ? initialValueQuery : null
	);

	useEffect(() => {
		setValue(initialValueQuery || null);
		if (!initialValueQuery) {
			setStartValue(null);
			setEndValue(null);
		}
	}, [initialValueQuery?.startOf, initialValueQuery?.endOf]);

	useEffect(() => {
		if (value && value.startOf && value.endOf && !initialValueQuery) {
			handleClick(value.startOf, value.endOf);
		}
	}, []);

	useEffect(() => {
		if (value && value.startOf && value.endOf) {
			const matchesQuery =
				initialValueQuery &&
				String(initialValueQuery.startOf) === String(value.startOf) &&
				String(initialValueQuery.endOf) === String(value.endOf);
			if (matchesQuery) {
				return;
			}
			handleClick(value.startOf, value.endOf);
		}
	}, [value]);

	const changeHandler = value => {
		setValue(value);
	};
	const simpleFuncMoment = (typeDay, hasStart) => {
		const date = hasStart
			? dayjs()
				.startOf(typeDay)
				.unix()
			: dayjs()
				.endOf(typeDay)
				.unix();

		return date + startHoursInSeconds;
	};

	const subtractFuncMoment = (typeDays, hasStart) => {
		return hasStart
			? dayjs()
				.subtract(1, typeDays)
				.startOf(typeDays)
				.unix()
			: dayjs()
				.subtract(1, typeDays)
				.endOf(typeDays)
				.unix();
	};

	const menuList = [
		{
			key: 1,
			onClick: () => {
				changeHandler({
					type: "day",
					startOf:
						dayjs()
							.startOf("day")
							.unix() + startHoursInSeconds,
					endOf:
						dayjs()
							.endOf("day")
							.unix() + startHoursInSeconds
				});
			},
			title: tr("Сегодня")
		},
		{
			key: 22,
			onClick: () => {
				changeHandler({
					type: "day",
					startOf:
						dayjs()
							.subtract(1, "day")
							.startOf("day")
							.unix() + startHoursInSeconds,
					endOf:
						dayjs()
							.subtract(1, "day")
							.endOf("day")
							.unix() + startHoursInSeconds
				});
			},
			title: tr("Вчера")
		},
		{
			key: 2,
			onClick: () => {
				changeHandler({
					type: "week",
					startOf: simpleFuncMoment("week", true),
					endOf: simpleFuncMoment("week", false)
				});
			},
			title: tr("Этa неделя")
		},
		{
			key: 3,
			title: tr("Этот месяц"),
			onClick: () => {
				changeHandler({
					type: "months",
					startOf: simpleFuncMoment("month", true),
					endOf: simpleFuncMoment("month", false)
				});
			}
		},
		{
			key: 4,
			onClick: () => {
				changeHandler({
					type: "months",
					startOf: subtractFuncMoment("months", true),
					endOf: subtractFuncMoment("months", false)
				});
			},
			title: tr("Прошлый месяц")
		},
		{
			key: 5,
			onClick: () => {
				changeHandler({
					type: "quarters",
					startOf: simpleFuncMoment("quarter", true),
					endOf: simpleFuncMoment("quarter", false)
				});
			},
			title: tr("Этот квартал")
		},
		{
			key: 6,
			onClick: () => {
				changeHandler({
					type: "quarters",
					startOf: subtractFuncMoment("quarters", true),
					endOf: subtractFuncMoment("quarters", false)
				});
			},
			title: tr("Прошлый квартал")
		},
		{
			key: 7,
			title: tr("Этот год"),
			onClick: () => {
				changeHandler({
					type: "years",
					startOf: simpleFuncMoment("year", true),
					endOf: simpleFuncMoment("year", false)
				});
			}
		},
		{
			key: 8,
			title: tr("Прошлый год"),
			onClick: () => {
				changeHandler({
					type: "years",
					startOf: subtractFuncMoment("years", true),
					endOf: subtractFuncMoment("years", false)
				});
			}
		}
	];

	const onStartChange = useCallback(value => {
		setStartValue(value);
	}, []);

	const onEndChange = useCallback(value => {
		setEndValue(value);
	}, []);

	const dateConvert = value => {
		if (get(value, "type") === "day") {
			return dayjs.unix(get(value, "startOf")).format("D MMM YYYY");
		} else if (get(value, "type") === "interval") {
			return `${get(value, "startOf")
					? dayjs.unix(get(value, "startOf")).format("D MMM")
					: ""
				} ${get(value, "startOf")
					? dayjs.unix(get(value, "startOf")).format("YYYY")
					: ""
				} ${get(value, "startOf") && get(value, "endOf") ? "-" : ""} ${get(value, "endOf")
					? dayjs.unix(get(value, "endOf")).format("D MMM")
					: ""
				} ${get(value, "endOf")
					? dayjs.unix(get(value, "endOf")).format("YYYY")
					: ""
				}`;
		} else {
			return `${get(value, "startOf")
					? dayjs.unix(get(value, "startOf")).format("D MMM")
					: ""
				} ${get(value, "startOf") && get(value, "endOf") ? "-" : ""} ${get(value, "endOf")
					? dayjs.unix(get(value, "endOf")).format("D MMM")
					: ""
				} ${dayjs.unix(get(value, "startOf")).format("YYYY")}`;
		}
	};

	const dynamicFunc = (value, count, type) => {
		if (type === "prev") {
			return {
				...value,
				startOf: dayjs
					.unix(get(value, "startOf"))
					.subtract(count, `${get(value, "type")}`)
					.startOf()
					.unix(),
				endOf: dayjs
					.unix(get(value, "endOf"))
					.subtract(count, `${get(value, "type")}`)
					.endOf()
					.unix()
			};
		} else {
			return {
				...value,
				startOf: dayjs
					.unix(get(value, "startOf"))
					.add(count, `${get(value, "type")}`)
					.startOf()
					.unix(),
				endOf: dayjs
					.unix(get(value, "endOf"))
					.add(count, `${get(value, "type")}`)
					.endOf()
					.unix()
			};
		}
	};

	const getDayValue = dayOffset => {
		const date = dayjs().add(dayOffset, "day");
		return {
			type: "day",
			startOf: date.startOf("day").unix() + startHoursInSeconds,
			endOf: date.endOf("day").unix() + startHoursInSeconds
		};
	};

	const shiftValueByDay = (currentValue, dayOffset) => {
		if (!currentValue?.startOf || !currentValue?.endOf) {
			return getDayValue(dayOffset);
		}

		const nextStart = dayjs.unix(currentValue.startOf).add(dayOffset, "day");
		const nextEnd = dayjs.unix(currentValue.endOf).add(dayOffset, "day");
		const isSingleDay = nextStart.isSame(nextEnd, "day");

		return {
			type: isSingleDay ? "day" : "interval",
			startOf: nextStart.unix(),
			endOf: nextEnd.unix()
		};
	};

	const prevHandler = () => {
		if (navigateByDay) {
			setValue(shiftValueByDay(value, -1));
			return;
		}

		if (get(value, "type") === "day") {
			setValue({
				type: "day",
				startOf:
					dayjs
						.unix(get(value, "startOf"))
						.subtract(1, "day")
						.startOf("day")
						.unix() + startHoursInSeconds,
				endOf:
					dayjs
						.unix(get(value, "startOf"))
						.subtract(1, "day")
						.endOf("day")
						.unix() + startHoursInSeconds
			});
		} else if (get(value, "type")) {
			setValue(dynamicFunc(value, 1, "prev"));
		} else {
			setValue(null);
		}
	};
	const nextHandler = () => {
		if (navigateByDay) {
			setValue(shiftValueByDay(value, 1));
			return;
		}

		if (get(value, "type") === "day") {
			setValue({
				type: "day",
				startOf: dayjs
					.unix(get(value, "startOf"))
					.add(1, "day")
					.startOf("day")
					.unix(),
				endOf: dayjs
					.unix(get(value, "startOf"))
					.add(1, "day")
					.endOf("day")
					.unix()
			});
		} else if (get(value, "type")) {
			setValue(dynamicFunc(value, 1, "next"));
		} else {
			setValue(null);
		}
	};

	const clearDateHandler = () => {
		setValue(null);
		setStartValue(null);
		setEndValue(null);
		setIsVisible(false);
		handleClear?.();
	};

	return (
		<div className="date-filter" ref={ref}>
			<div className="date-filter-head">
				<span className="date-filter-head__button --prev" onClick={prevHandler}>
					<img src={ArrowRightIcon} alt="" />
				</span>
				<span
					className="date-filter-head__value"
					onClick={() => setIsVisible(true)}
				>
					{value ? dateConvert(value) : tr("Выберите дату")}
				</span>
				{handleClear && value ? (
					<span
						className="date-filter-head__button --clear"
						onClick={clearDateHandler}
						title={tr("Очистить")}
					>
						×
					</span>
				) : null}
				<span className="date-filter-head__button --next" onClick={nextHandler}>
					<img src={ArrowRightIcon} alt="" />
				</span>
			</div>
			<div
				className={`date-filter-menu ${isVisible ? "--visible" : ""
					} dropdown-pos-${dropdownPosition}`}
			>
				<div>
					{menuList.map(menuItem => {
						return (
							<div
								key={menuItem.key}
								onClick={() => {
									menuItem.onClick();
									setIsVisible(false);
								}}
								className="date-filter-menu__item"
							>
								{menuItem.title}
							</div>
						);
					})}
					{handleClear && value ? (
						<div
							onClick={clearDateHandler}
							className="date-filter-menu__item date-filter-menu__item--clear"
						>
							{tr("Очистить")}
						</div>
					) : null}
				</div>
				<div className="date-filter-menu__datepickers">
					<Fields.NewDatePickerDefault
						placeholder="01.01.2023"
						format="dd.MM.yyyy HH:mm"
						className=""
						customChange={true}
						value={startValue}
						handleChange={date => {
							onStartChange(date);
						}}
					/>
					<span className={"fw-600 mr-10 ml-10"}>-</span>
					<Fields.NewDatePickerDefault
						placeholder="01.01.2023"
						format="dd.MM.yyyy HH:mm"
						className=""
						customChange={true}
						value={endValue}
						handleChange={date => {
							onEndChange(date);
						}}
					/>
					<button
						className="submit-button"
						onClick={() => {
							if (startValue || endValue) {
								changeHandler({
									type: "interval",
									startOf: dayjs(startValue).unix(),
									endOf: dayjs(endValue).unix()
								});
								setIsVisible(false);
							}
						}}
					>
						OK
					</button>
				</div>
			</div>
		</div>
	);
};

export default Index;
